import { readApiErrorMessage } from "../postulacionesUtils";
import { IPrefilterDraft, IPrefilterSummaryResponse, draftToPayload } from "./prefiltradoTypes";

const baseUrl = () => {
  const url = process.env.REACT_APP_API_APPLICANT;
  if (!url) throw new Error("Configuración faltante: REACT_APP_API_APPLICANT");
  return url;
};

const currentUserId = () => {
  const userId = sessionStorage.getItem("usuarioId") ?? "";
  if (!userId) throw new Error("No se pudo identificar el usuario actual.");
  return userId;
};

export async function fetchPrefilterSummary(signal?: AbortSignal): Promise<IPrefilterSummaryResponse> {
  const res = await fetch(
    `${baseUrl()}/prefilter/summary?userId=${encodeURIComponent(currentUserId())}`,
    { signal },
  );
  if (!res.ok) throw new Error(await readApiErrorMessage(res));
  const data = await res.json();
  return {
    canEdit: data?.canEdit === true,
    prefilters: Array.isArray(data?.prefilters) ? data.prefilters : [],
  };
}

export async function savePrefilter(draft: IPrefilterDraft): Promise<string> {
  const res = await fetch(`${baseUrl()}/prefilter/save`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ userId: currentUserId(), prefilter: draftToPayload(draft) }),
  });
  if (!res.ok) throw new Error(await readApiErrorMessage(res));
  const data = await res.json();
  return data?.prefilterId;
}

export interface ICatalogItem {
  value: string;
  label: string;
  group?: string;
}

/** Catálogos que usa el editor. Una falla en uno no impide abrir el editor. */
export async function fetchEditorCatalogs(): Promise<{
  clients: ICatalogItem[];
  localities: ICatalogItem[];
  positions: ICatalogItem[];
  shifts: ICatalogItem[];
}> {
  const get = async (resource: string) => {
    const res = await fetch(`${baseUrl()}/catalogs/${resource}`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  };
  const safe = <T,>(promise: Promise<T>, fallback: T) => promise.catch(() => fallback);

  const [clients, localities, positions, shifts] = await Promise.all([
    safe(get("clients"), { clients: [] }),
    safe(get("localities"), { localities: [] }),
    safe(get("positions"), { positions: [] }),
    safe(get("shifts"), { shifts: [] }),
  ]);

  return {
    clients: (clients.clients ?? []).map((c: any) => ({ value: String(c.clientId), label: String(c.name) })),
    localities: (localities.localities ?? []).map((l: any) => ({
      value: String(l.localityId),
      label: String(l.name),
      group: l.region ? String(l.region) : undefined,
    })),
    positions: (positions.positions ?? []).map((p: any) => ({ value: String(p.name).toUpperCase(), label: String(p.name) })),
    shifts: (shifts.shifts ?? []).map((s: any) => ({ value: String(s.name), label: String(s.name) })),
  };
}
